import {createReducer, on} from '@ngrx/store';
import * as SnapshotActions from './snapshot.actions';
import {StudySnapshotDTO} from '../dto/study-snapshot';


export interface SnapshotState {
  snapshot: StudySnapshotDTO | null;
  loading: boolean;
  error: any;
}

export const initialState: SnapshotState = {
  snapshot: null,
  loading: false,
  error: null
};

export const snapshotReducer = createReducer(
  initialState,
  on(SnapshotActions.loadSnapshot, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SnapshotActions.loadSnapshotSuccess, (state, {snapshot}) => ({
    ...state,
    snapshot,
    loading: false,
    error: null
  })),
  on(SnapshotActions.loadSnapshotFailure, (state, {error}) => ({
    ...state,
    loading: false,
    error
  }))
);
